/*eslint-disable*/
// chakra imports
import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
  Avatar,
  Icon,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import IconBox from "components/Icons/IconBox";
import { SpotifyLogo } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ProfileIcon } from "components/Icons/Icons";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { userSignOut } from "appRedux/actions/Auth";
import InfoPanel from "./InfoPanel";
import SidebarLink from "./SidebarLink";

// this function creates the links and collapses that appear in the sidebar (left menu)

const SidebarContent = ({ logoText, routes }) => {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});

  const dispatch = useDispatch();

  const activeColor = useColorModeValue("gray.700", "white");

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName) ? "active" : "";
  };

  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }

      if (prop.separator) {
        return (
          <Separator
          my ={2}
            key={`separator-${key}`}
            hasTitle={prop.separator}
            
          />
        );
      }
      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{
                xl: "12px",
              }}
              mx="auto"
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py="10px"
            >
              {prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      const isActive = activeRoute(prop.path) === "active";

      return (
        <SidebarLink
          key={prop.name}
          prop={prop}
          isActive={isActive}
          onSignOut={() => dispatch(userSignOut())}
        />
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  /* return (
    <>
      <InfoPanel />
      <Stack direction="column" mb="40px">
        <Box>{links}</Box>
      </Stack>
    </>
  ); */
  return (
    <>
      <motion.div
        className="sidebar-scroll"
        style={{
          direction: "ltr",
          overflowY: "auto",
          height: "100vh",
          maxHeight: "100vh",
          /* paddingTop:"15px", */
          paddingBottom: "15px",
          paddingTop: "5px"
        }}
      >
        <div
          style={{
            direction: "rtl",
            paddingRight: "10px",
            paddingTop: "10px",
          }}
        >
          <Stack direction="column">
            <Box>{links}</Box>
          </Stack>
        </div>
      </motion.div>
    </>
  );
};

export default SidebarContent;
